import { findDirVisibilities } from './palletedge'

// possible label positions in the anti-clockwise order of the pallet coordinate system
const LPOSITIONS = ['S', 'SE', 'E', 'NE', 'N', 'NW', 'W', 'SW']

function lposRotate (lpos, deg) {
  const mod = (n, m) => ((n % m) + m) % m
  const idx = LPOSITIONS.indexOf(lpos)
  return LPOSITIONS[mod(idx + Math.floor(mod(deg, 360) / 45), LPOSITIONS.length)]
}

/** Find WNES bounding box of passed boxes. */
function findBBox (boxes) {
  return boxes.slice(1).reduce(({ W, N, E, S }, b) =>
    ({
      W: Math.min(W, b.W),
      N: Math.min(N, b.N),
      E: Math.max(E, b.E),
      S: Math.max(S, b.S)
    }),
  { W: boxes[0].W, N: boxes[0].N, E: boxes[0].E, S: boxes[0].S })
}

/**
 * labelPos is FRONT (west), FRONT_RIGHT_CORNER (north west), RIGHT (north), RIGHT_BACK_CORNER (north east),
 * BACK (east), BACK_LEFT_CORNER (south east), LEFT (south) and LEFT_FRONT_CORNER (south west)
 * Origin is top-left, rotation clockwise, important for labelPos.
 */
export function convertBoxesToPE ({ w, h, labelPos }, boxes) {
  const wh = w / 2; const hh = h / 2
  const rotW = (x, _, r) => (r === 0 || r === 180) ? x - wh : x - hh
  const rotN = (_, y, r) => (r === 0 || r === 180) ? y - hh : y - wh
  const rotE = (x, _, r) => (r === 0 || r === 180) ? x + wh : x + hh
  const rotS = (_, y, r) => (r === 0 || r === 180) ? y + hh : y + wh
  const baseLabel = { FRONT: 'W', FRONT_RIGHT_CORNER: 'NW', RIGHT: 'N', RIGHT_BACK_CORNER: 'NE', BACK: 'E', BACK_LEFT_CORNER: 'SE', LEFT: 'S', LEFT_FRONT_CORNER: 'SW' }[labelPos]

  return boxes.map(({ x, y, rotation: r, id }) =>
    ({ W: rotW(x, y, r), N: rotN(x, y, r), E: rotE(x, y, r), S: rotS(x, y, r), lpos: lposRotate(baseLabel, r), id }))
}

/** mainly for debug, just visibilities */
export function findBoxVisibilities (env, appBoxes) {
  const boxes = convertBoxesToPE(env, appBoxes)
  return boxes.map(b => findDirVisibilities(b, boxes))
}

export function findBox180DegRotates (env, appBoxes) {
  if (appBoxes.length === 0) { return [] }

  const boxes = convertBoxesToPE(env, appBoxes)
  const vises = boxes.map(b => findDirVisibilities(b, boxes))
  const bbox = findBBox(boxes)

  function lposVis (lpos, { visW, visN, visE, visS }) {
    return [
      visS, (visS + visE) / 2, visE, (visE + visN) / 2,
      visN, (visN + visW) / 2, visW, (visW + visS) / 2
    ][LPOSITIONS.indexOf(lpos)]
  }

  function lposEdgeDist (lpos, box) {
    const findBoxWidth = b => b.E - b.W; const findBoxHeight = b => b.S - b.N
    const normWidth = findBoxWidth(bbox) - findBoxWidth(box)
    const normHeight = findBoxHeight(bbox) - findBoxHeight(box)

    return [...lpos].reduce((acc, c) =>
      Math.min(acc, (Math.abs(bbox[c] - box[c]) / ((c === 'W' || c === 'E') ? normWidth : normHeight))),
    Number.POSITIVE_INFINITY)
  }

  return boxes.map((box, i) => {
    const v0 = lposVis(box.lpos, vises[i])
    const v180 = lposVis(lposRotate(box.lpos, 180), vises[i])

    // console.log('foo: ', box.lpos, lposEdgeDist(box.lpos, box), lposEdgeDist(lposRotate(box.lpos, 180), box))

    return (v0 === 1 && v180 === 1) // use closer to bbox edge in dir lpos to find rotate 180
      ? lposEdgeDist(box.lpos, box) > lposEdgeDist(lposRotate(box.lpos, 180), box)
      : v0 < v180
  })
}
